import './App.css';

function App() {
  return (
    <div className="App">
      <div className="hero-container">
        {/* Decorative Elements */}
        <div className="deco code-brackets">&lt;/&gt;</div>
        <div className="deco curly-braces">&#123;...&#125;</div>
        <div className="deco comment">/**/</div>
        <div className="deco slashes">//</div>
        <div className="deco arrow">-&gt;</div>
        
        {/* Profile Image */}
        <div className="profile-container">
          <div className="profile-image">
            <div className="profile-placeholder"></div>
          </div>
        </div>
        
        {/* Main Content */}
        <div className="hero-content">
          <h1 className="hello-text">HELLO, I'M</h1>
          
          <div className="name-container">
            <span className="name-highlight">Prashanth Sobbani</span>
            <span className="name-shadow" aria-hidden="true"></span>
          </div>
          
          <div className="title-container">
            <span className="title-box">SR SOFTWARE ENGINEER</span>
            <span className="title-shadow" aria-hidden="true"></span>
          </div>
          
          {/* Buttons */}
          <div className="button-group">
            <button className="btn btn-primary">VIEW MY WORK</button>
            <button className="btn btn-secondary">GET IN TOUCH</button>
          </div>
          
          {/* Social Icons */}
          <div className="social-icons">
            <a href="#" className="social-link github" aria-label="GitHub">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
              </svg>
            </a>
            <a href="#" className="social-link linkedin" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
            <a href="#" className="social-link email" aria-label="Email">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      {/* About/Bio Section */}
      <section className="about-section">
        <div className="about-container">
          <div className="experience-badge">
            <span className="experience-number">8+</span>
            <span className="experience-text">Years of<br/>Experience</span>
          </div>
          <div className="about-content">
            <h2 className="about-heading">About Me</h2>
            <p className="about-text">
              I'm a passionate software developer with a strong focus on building scalable and user-friendly applications. I enjoy turning ideas into real-world solutions, especially in areas like mobile apps, AI-driven features, and modern web technologies. With experience in creating server-side rendered applications and integrating smart, data-driven functionality, I'm always exploring ways to improve performance and user experience. I'm driven by curiosity, continuous learning, and a desire to build products that make everyday life simpler and more efficient.
            </p>
            <div className="about-cta">
              <button className="btn btn-primary">Download Resume</button>
            </div>
          </div>
        </div>
      </section>
      
      {/* Skills Section */}
      <div className="skills-section">
        {/* Intro Banner */}
        <div className="skills-intro">
          <p>From frontend to backend, I've worked with diverse technologies and frameworks to deliver complete solutions. Here's an overview of my core expertise.</p>
        </div>
        
        {/* Skills Grid */}
        <div className="skills-grid">
          {/* Frontend Dev */}
          <div className="skill-card frontend">
            <h3 className="skill-title">FRONTEND DEV</h3>
            <div className="skill-tags">
              <span className="skill-tag">React.js</span>
              <span className="skill-tag">Next.js</span>
              <span className="skill-tag">Angular</span>
              <span className="skill-tag">SASS</span>
              <span className="skill-tag">jQuery</span>
              <span className="skill-tag">HTML/CSS</span>
              <span className="skill-tag">Tailwind CSS</span>
              <span className="skill-tag">Material UI</span>
              <span className="skill-tag">Cypress</span>
            </div>
          </div>
          
          {/* Backend Dev */}
          <div className="skill-card backend">
            <h3 className="skill-title">BACKEND DEV</h3>
            <div className="skill-tags">
              <span className="skill-tag">Node.js</span>
              <span className="skill-tag">Express</span>
              <span className="skill-tag">Nest.js</span>
              <span className="skill-tag">ASP.NET Core</span>
              <span className="skill-tag">Flask</span>
              <span className="skill-tag">MongoDB</span>
              <span className="skill-tag">PostgreSQL and MySQL</span>
              <span className="skill-tag">Jest</span>
              <span className="skill-tag">Redis</span>
            </div>
          </div>
        </div>
        
        {/* Other Skills */}
        <div className="skill-card other-skills">
          <h3 className="skill-title">OTHER SKILLS & TOOLS</h3>
          <div className="skill-tags">
            <span className="skill-tag">JavaScript</span>
            <span className="skill-tag">TypeScript</span>
            <span className="skill-tag">Python</span>
            <span className="skill-tag">C#</span>
            <span className="skill-tag">GitHub</span>
            <span className="skill-tag">RESTful API</span>
            <span className="skill-tag">GraphQL</span>
            <span className="skill-tag">CI/CD</span>
            <span className="skill-tag">Docker</span>
            <span className="skill-tag">AWS</span>
            <span className="skill-tag">Firebase</span>
            <span className="skill-tag">Figma</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
